import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM201InvoicesConfig} from './getAccountingMatrixDatagridM201InvoicesConfig';

export function AccountingMatrixDatagridM201Invoices() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM201InvoicesConfig()} />;
}
